<div class="row">
  <div class="col-md-6">
    <app-form-group><label>Id</label><input class="form-control" [(ngModel)]="berth.id" disabled required></app-form-group>
    <app-form-group><label>Port code</label>
      <app-select id="port" [(ngModel)]="berth.portCode" [optionsProvider]="portsOfCall" required
                  [addSelectedIfNotExists]="true" placeholder="– Select a port –">
      </app-select>
    </app-form-group>
    <app-form-group><label>Name</label><input class="form-control" [(ngModel)]="berth.name" required></app-form-group>
    <app-form-group><label>Short name</label><input class="form-control" [(ngModel)]="berth.shortName">
    </app-form-group>
    <app-form-group><label>Code</label><input class="form-control" [(ngModel)]="berth.code" required></app-form-group>
    <app-form-group><label>Global location number</label><input class="form-control" [(ngModel)]="berth.globalLocationNumber" disabled></app-form-group>
    <app-form-group><label>Harbour Area</label><input class="form-control" [(ngModel)]="berth.harbourArea"></app-form-group>
    <app-form-group><label>Harbour Dues Area</label><app-yes-no [(ngModel)]="berth.harbourDuesArea" id="harbourDuesArea"></app-yes-no></app-form-group>
  </div>
  <div class="col-md-6">
    <app-form-group><label>Terminal</label>
      <app-search [ngModel]="berth" [searchFunction]="$any(searchTerminal)" (ngModelChange)="setTerminal($event)"
                  id="terminal" required placeholder="Find terminal" [inputFormatter]="terminalFormatter">
      </app-search>
    </app-form-group>
    <app-form-group><label>Berth group code</label><input class="form-control" [(ngModel)]="berth.berthGroupCode"></app-form-group>
    <app-form-group><label>Buoy</label><app-yes-no [(ngModel)]="berth.buoy" required id="buoy"></app-yes-no></app-form-group>
    <app-form-group><label>Bollard from</label><input type="number" class="form-control" [ngModel]="berth.bollards?.start" (ngModelChange)="setBollards($event, true)" [required]="!!this.berth.bollards"></app-form-group>
    <app-form-group><label>Bollard to</label><input type="number" class="form-control" [ngModel]="berth.bollards?.end" (ngModelChange)="setBollards($event, false)" [required]="!!this.berth.bollards"></app-form-group>
    <app-form-group><label>Party to notify</label><input class="form-control" [(ngModel)]="berth.partyToNotify"></app-form-group>
    <app-form-group>
      <label>Municipality</label>
      <app-select id="municipality" [(ngModel)]="berth.municipalityUnlocode" [options]="municipalityUnlocodes"
                  placement="top-end" title="Select municipality" [required]="inPortOfRotterdam()"
                  [formatter]="formatMunicipality" [disabled]="!inPortOfRotterdam()">
      </app-select>
    </app-form-group>
  </div>
</div>
